/* Vidéos Blushy : lecture muette seulement quand la vidéo est visible, son au toucher (une seule à la fois).
   Conteneur : [data-bs-vid] (avec son au clic) ou [data-bs-vid="loop"] (boucle muette, pas de son).
   Bouton optionnel : [data-bs-sound]. Mouvement réduit : rien ne démarre seul, le toucher lance avec le son. */
(function () {
  if (window.__bsVid) return;
  window.__bsVid = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function vid(w) { return w.querySelector('video'); }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  function setSound(w, on) {
    var v = vid(w);
    if (!v) return;
    if (on) {
      document.querySelectorAll('[data-bs-vid].is-sound').forEach(function (o) { if (o !== w) setSound(o, false); });
      v.muted = false; v.volume = 1;
      try { v.currentTime = 0; } catch (e) {}
      play(v);
    } else {
      v.muted = true;
      if (reduce) v.pause();
    }
    w.classList.toggle('is-sound', on);
    var b = w.querySelector('[data-bs-sound]');
    if (b) {
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Couper le son' : 'Activer le son');
    }
  }

  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-bs-vid]');
    if (!w || w.getAttribute('data-bs-vid') === 'loop' || !vid(w)) return;
    if (e.target.closest('a')) return;
    e.preventDefault();
    setSound(w, !w.classList.contains('is-sound'));
  });

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var w = en.target, v = vid(w);
      if (!v) return;
      if (en.isIntersecting) {
        if (!reduce || w.classList.contains('is-sound')) play(v);
      } else {
        v.pause();
        if (w.classList.contains('is-sound')) setSound(w, false);
      }
    });
  }, { threshold: 0.35 }) : null;

  /* Poster différé : l'image d'aperçu n'est demandée que quand la vidéo arrive à 600 px de l'écran. */
  var near = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var v = vid(en.target);
      if (v && v.dataset.poster && !v.poster) { v.poster = v.dataset.poster; }
      near.unobserve(en.target);
    });
  }, { rootMargin: '600px 0px' }) : null;

  function init() {
    document.querySelectorAll('[data-bs-vid]').forEach(function (w) {
      if (w.__bsInit) return;
      var v = vid(w);
      if (!v) return;
      w.__bsInit = true;
      if (v.dataset.poster && !v.poster) { if (near) near.observe(w); else v.poster = v.dataset.poster; }
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; v.loop = true;
      if (io) io.observe(w); else if (!reduce) play(v);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
